import React from "react";
import {withRouter} from "react-router-dom";
import {LayoutWithHeader} from "../components/LayoutWithHeader";
import {useAuth} from "../contexts/auth";

const BookmarksInner = () => {
	const authContext = useAuth()
	return (
		<>
			<LayoutWithHeader title={"Bookmarks"}>
				<div>Not Implemented Yet.</div>
			</LayoutWithHeader>
		</>
	)
}


export const Bookmarks = withRouter(BookmarksInner);